import { spacing } from "@minuthq/meatball-ui-react"

import { IntegrationsCardSkeleton } from "src/components/Integrations/IntegrationsCardSkeleton"
import { MCircularProgress } from "src/ui/MCircularProgress/MCircularProgress"
import { MSkeleton } from "src/ui/MSkeleton/MSkeleton"

import {
  CircularProgressWrapper,
  IntegrationStatusContent,
  IntegrationStatusSection,
  LinkedIntegrationsList,
  StyledMCard,
} from "./sharedStyles"

export function IntegrationStatusSkeletion() {
  return (
    <StyledMCard padding={spacing.M} boxShadow={false} border={true}>
      <MSkeleton width="20ch" />
      <IntegrationStatusContent>
        <IntegrationStatusSection>
          <CircularProgressWrapper>
            <MCircularProgress />
          </CircularProgressWrapper>
        </IntegrationStatusSection>
        <IntegrationStatusSection>
          <LinkedIntegrationsList>
            {Array.from(Array(3), (_, index) => (
              <IntegrationsCardSkeleton key={index} boxShadow={false} border />
            ))}
          </LinkedIntegrationsList>
        </IntegrationStatusSection>
      </IntegrationStatusContent>
    </StyledMCard>
  )
}
